function e() {
  return e = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var c in n) Object.prototype.hasOwnProperty.call(n, c) && (e[c] = n[c]);
    }
    return e;
  }, e.apply(this, arguments);
}
const t = {
    desc: "е -> je am Wortanfang, nach ь / ъ / Vokalen",
    cond: _ref => {
      let {
        c: e,
        prev: t,
        isVowel: n
      } = _ref;
      return "е" === e && (n(t) || ["", "ь", "ъ"].includes(t));
    },
    val: "je",
    range: [-1, 1]
  },
  n = [{
    desc: "кс -> x",
    cond: _ref2 => {
      let {
        c: e,
        next: t
      } = _ref2;
      return "к" === e && "с" === t;
    },
    val: "x",
    range: [0, 2]
  }, {
    cond: _ref3 => {
      let {
        c: e,
        prev: t
      } = _ref3;
      return "с" === e && "к" === t;
    },
    val: ""
  }],
  c = {
    desc: "с -> ss zwischen zwei Vokalen",
    cond: _ref4 => {
      let {
        c: e,
        isVowel: t,
        prev: n,
        next: c
      } = _ref4;
      return "с" === e && t(n) && t(c);
    },
    val: "ss",
    range: [-1, 2]
  },
  s = [{
    desc: "й -> j zwischen zwei Vokalen",
    cond: _ref5 => {
      let {
        c: e,
        prev: t,
        next: n,
        isVowel: c
      } = _ref5;
      return "й" === e && c(t) && c(n);
    },
    val: "j",
    range: [-1, 2]
  }, {
    desc: "ьи -> ji, ьо -> jo",
    cond: _ref6 => {
      let {
        c: e,
        next: t
      } = _ref6;
      return "ь" === e && ["i", "и", "о"].includes(t);
    },
    val: "j",
    range: [0, 2]
  }],
  o = [{
    from: "be",
    to: "de",
    dict: {
      а: "a",
      б: "b",
      в: "w",
      г: "h",
      д: "d",
      е: "e",
      ё: "jo",
      ж: "sh",
      з: "s",
      і: "i",
      й: "i",
      к: "k",
      л: "l",
      м: "m",
      н: "n",
      о: "o",
      п: "p",
      р: "r",
      с: "s",
      т: "t",
      у: "u",
      ў: "u",
      ф: "f",
      х: "ch",
      ц: "z",
      ч: "tsch",
      ш: "sch",
      ы: "y",
      ь: "",
      э: "e",
      ю: "ju",
      я: "ja"
    },
    rules: [t, ...n, c, ...s, {
      desc: "й nicht wiedergegeben nach ы und і",
      cond: _ref7 => {
        let {
          c: e,
          prev: t
        } = _ref7;
        return "й" === e && ["ы", "і"].includes(t);
      },
      val: "",
      range: [-1, 1]
    }, {
      desc: "V statt W am Wortbeginn (gebräuchliche Namensschreibung)",
      cond: _ref8 => {
        let {
          c: e,
          w: t
        } = _ref8;
        return "в" === e && !!t.match(/^(валянцін|віктар|веранік)/i);
      },
      val: "v"
    }]
  }, {
    from: "be",
    to: "en",
    dict: {
      а: "a",
      б: "b",
      в: "v",
      г: "h",
      д: "d",
      е: "e",
      ё: "yo",
      ж: "zh",
      з: "z",
      і: "i",
      й: "i",
      к: "k",
      л: "l",
      м: "m",
      н: "n",
      о: "o",
      п: "p",
      р: "r",
      с: "s",
      т: "t",
      у: "u",
      ў: "u",
      ф: "f",
      х: "kh",
      ц: "ts",
      ч: "ch",
      ш: "sh",
      ы: "y",
      ь: "",
      э: "e",
      ю: "yu",
      я: "ya"
    }
  }, {
    from: "be",
    to: "scientific",
    dict: {
      а: "a",
      б: "b",
      в: "v",
      г: "h",
      д: "d",
      е: "e",
      ё: "ё",
      ж: "ž",
      з: "z",
      і: "i",
      й: "j",
      к: "k",
      л: "l",
      м: "m",
      н: "n",
      о: "o",
      п: "p",
      р: "r",
      с: "s",
      т: "t",
      у: "u",
      ў: "ŭ",
      ф: "f",
      х: "ch",
      ц: "c",
      ч: "č",
      ш: "š",
      ы: "y",
      ь: "ʹ",
      э: "ė",
      ю: "ju",
      я: "ja",
      "'": "’",
      "’": "’",
      ʼ: "’"
    }
  }],
  i = [{
    from: "ru",
    to: "de",
    dict: {
      а: "a",
      б: "b",
      в: "w",
      г: "g",
      д: "d",
      е: "e",
      ё: "jo",
      ж: "sh",
      з: "s",
      и: "i",
      й: "i",
      к: "k",
      л: "l",
      м: "m",
      н: "n",
      о: "o",
      п: "p",
      р: "r",
      с: "s",
      т: "t",
      у: "u",
      ф: "f",
      х: "ch",
      ц: "z",
      ч: "tsch",
      ш: "sch",
      щ: "schtsch",
      ъ: "",
      ы: "y",
      ь: "",
      э: "e",
      ю: "ju",
      я: "ja"
    },
    rules: [t, ...n, c, ...s, {
      desc: "й nicht wiedergegeben nach ы und и",
      cond: _ref9 => {
        let {
          c: e,
          prev: t
        } = _ref9;
        return "й" === e && ["ы", "и"].includes(t);
      },
      val: "",
      range: [-1, 1]
    }, {
      desc: "ё -> o nach ж / ч / ш / щ",
      cond: _ref10 => {
        let {
          c: e,
          prev: t
        } = _ref10;
        return "ё" === e && ["ж", "ч", "ш", "щ"].includes(t);
      },
      val: "o",
      range: [-1, 1]
    }, {
      desc: "-ого/-его -> -owo/-ewo am Wortende",
      cond: _ref11 => {
        let {
          c: e,
          prev: t,
          next: n,
          charAtPos: c
        } = _ref11;
        return "г" === e && ["е", "о"].includes(t) && "о" === n && "" === c(2);
      },
      val: "w",
      range: [-1, 2]
    }, {
      desc: "Александр -> Alexander (gebräuchliche Namensschreibung)",
      cond: _ref12 => {
        let {
          c: e,
          w: t
        } = _ref12;
        return "д" === e && "александр" === t;
      },
      val: "de",
      range: [0, 2]
    }, {
      desc: "Дмитрий -> Dimitri (gebräuchliche Namensschreibung)",
      cond: _ref13 => {
        let {
          c: e,
          w: t
        } = _ref13;
        return "д" === e && "дмитрий" === t;
      },
      val: "di",
      range: [0, 2]
    }, {
      desc: "j statt i am Wortende (gebräuchliche Namensschreibung)",
      cond: _ref14 => {
        let {
          c: e,
          w: t
        } = _ref14;
        return "й" === e && ["алексей", "сергей"].includes(t);
      },
      val: "j"
    }, {
      desc: "V statt W am Wortbeginn (gebräuchliche Namensschreibung)",
      cond: _ref15 => {
        let {
          c: e,
          w: t
        } = _ref15;
        return "в" === e && !!t.match(/^(валентин|виктор|вероник)/i);
      },
      val: "v"
    }]
  }, {
    from: "ru",
    to: "en",
    dict: {
      а: "a",
      б: "b",
      в: "v",
      г: "g",
      д: "d",
      е: "e",
      ё: "yo",
      ж: "zh",
      з: "z",
      и: "i",
      й: "i",
      к: "k",
      л: "l",
      м: "m",
      н: "n",
      о: "o",
      п: "p",
      р: "r",
      с: "s",
      т: "t",
      у: "u",
      ф: "f",
      х: "kh",
      ц: "ts",
      ч: "ch",
      ш: "sh",
      щ: "sch",
      ъ: "",
      ы: "y",
      ь: "",
      э: "e",
      ю: "yu",
      я: "ya"
    }
  }, {
    from: "ru",
    to: "scientific",
    dict: {
      а: "a",
      б: "b",
      в: "v",
      г: "g",
      д: "d",
      е: "e",
      ё: "ё",
      ж: "ž",
      з: "z",
      и: "i",
      й: "j",
      к: "k",
      л: "l",
      м: "m",
      н: "n",
      о: "o",
      п: "p",
      р: "r",
      с: "s",
      т: "t",
      у: "u",
      ф: "f",
      х: "ch",
      ц: "c",
      ч: "č",
      ш: "š",
      щ: "šč",
      ъ: "ʺ",
      ы: "y",
      ь: "ʹ",
      э: "ė",
      ю: "ju",
      я: "ja",
      "'": "’",
      "’": "’",
      ʼ: "’"
    }
  }],
  r = [{
    from: "uk",
    to: "de",
    dict: {
      а: "a",
      б: "b",
      в: "w",
      г: "h",
      ґ: "g",
      д: "d",
      е: "e",
      є: "e",
      ж: "sh",
      з: "s",
      и: "y",
      і: "i",
      ї: "ji",
      й: "i",
      к: "k",
      л: "l",
      м: "m",
      н: "n",
      о: "o",
      п: "p",
      р: "r",
      с: "s",
      т: "t",
      у: "u",
      ф: "f",
      х: "ch",
      ц: "z",
      ч: "tsch",
      ш: "sch",
      щ: "schtsch",
      ь: "",
      ю: "ju",
      я: "ja",
      "'": "",
      "’": "",
      ʼ: ""
    },
    rules: [{
      desc: "є -> je am Wortanfang, nach ь und Vokalen",
      cond: _ref16 => {
        let {
          c: e,
          prev: t,
          isVowel: n
        } = _ref16;
        return "є" === e && (n(t) || ["", "ь"].includes(t));
      },
      val: "je",
      range: [-1, 1]
    }, ...n, c, {
      desc: "й nicht wiedergegeben nach и",
      cond: _ref17 => {
        let {
          c: e,
          prev: t
        } = _ref17;
        return "й" === e && "и" === t;
      },
      val: "",
      range: [-1, 1]
    }, ...s, {
      desc: "V statt W am Wortbeginn (gebräuchliche Namensschreibung)",
      cond: _ref18 => {
        let {
          c: e,
          w: t
        } = _ref18;
        return "в" === e && !!t.match(/^(валентин|віктор|веронік)/i);
      },
      val: "v"
    }]
  }, {
    from: "uk",
    to: "en",
    dict: {
      а: "a",
      б: "b",
      в: "v",
      г: "h",
      ґ: "g",
      д: "d",
      е: "e",
      є: "ie",
      ж: "zh",
      з: "z",
      и: "y",
      і: "i",
      ї: "i",
      й: "i",
      к: "k",
      л: "l",
      м: "m",
      н: "n",
      о: "o",
      п: "p",
      р: "r",
      с: "s",
      т: "t",
      у: "u",
      ф: "f",
      х: "kh",
      ц: "ts",
      ч: "ch",
      ш: "sh",
      щ: "shch",
      ь: "",
      ю: "iu",
      я: "ia",
      "'": "",
      "’": "",
      ʼ: ""
    },
    rules: [{
      desc: "є -> ye at the beginning of the word",
      cond: _ref19 => {
        let {
          c: e,
          prev: t
        } = _ref19;
        return "є" === e && "" === t;
      },
      val: "ye"
    }, {
      desc: "ї -> yi at the beginning of the word",
      cond: _ref20 => {
        let {
          c: e,
          prev: t
        } = _ref20;
        return "ї" === e && "" === t;
      },
      val: "yi"
    }, {
      desc: "й -> y at the beginning of the word",
      cond: _ref21 => {
        let {
          c: e,
          prev: t
        } = _ref21;
        return "й" === e && "" === t;
      },
      val: "y"
    }, {
      desc: "ю -> yu at the beginning of the word",
      cond: _ref22 => {
        let {
          c: e,
          prev: t
        } = _ref22;
        return "ю" === e && "" === t;
      },
      val: "yu"
    }, {
      desc: "я -> ya at the beginning of the word",
      cond: _ref23 => {
        let {
          c: e,
          prev: t
        } = _ref23;
        return "я" === e && "" === t;
      },
      val: "ya"
    }, {
      desc: "зг -> zgh",
      cond: _ref24 => {
        let {
          c: e,
          prev: t
        } = _ref24;
        return "г" === e && "з" === t;
      },
      val: "gh",
      range: [-1, 1]
    }]
  }, {
    from: "uk",
    to: "scientific",
    dict: {
      а: "a",
      б: "b",
      в: "v",
      г: "h",
      ґ: "g",
      д: "d",
      е: "e",
      є: "je",
      ж: "ž",
      з: "z",
      и: "y",
      і: "i",
      ї: "ji",
      й: "j",
      к: "k",
      л: "l",
      м: "m",
      н: "n",
      о: "o",
      п: "p",
      р: "r",
      с: "s",
      т: "t",
      у: "u",
      ф: "f",
      х: "ch",
      ц: "c",
      ч: "č",
      ш: "š",
      щ: "šč",
      ь: "ʹ",
      ю: "ju",
      я: "ja",
      "'": "’",
      "’": "’",
      ʼ: "’"
    }
  }],
  a = ["а", "е", "є", "ё", "и", "і", "ї", "о", "у", "ы", "ю", "э", "я"];
function d(e) {
  return a.includes(e);
}
function h(e) {
  return e === e.toUpperCase();
}
class l {
  constructor(e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
    this.def = void 0, this.alphabet = void 0, this.appliedRules = void 0, this.debug = void 0, this.def = e, this.alphabet = Object.keys(this.def.dict), this.appliedRules = [], this.debug = t, this.debug && console.log(this.alphabet);
  }
  transcribe() {
    let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    const t = (e = e.normalize()).split(" ");
    let n = e;
    for (let e of t) e = this.clean(e), n = n.replace(e, this.transcribeWord(e));
    const {
      appliedRules: c,
      def: s
    } = this;
    return {
      output: n,
      appliedRules: c,
      from: s.from,
      to: s.to
    };
  }
  transcribeWord() {
    let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    return e.trim().split("").reduce((t, n, c, s) => {
      var o, i;
      return t + function () {
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
        let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
        return h(n) ? e.toUpperCase() : h(t) ? function (e) {
          const [t, ...n] = e;
          return t ? [t.toUpperCase(), ...n].join("") : "";
        }(e) : e;
      }(null != (o = null != (i = this.getRuleBasedChar(n, c, s, e)) ? i : this.getDictChar(n)) ? o : n, n, e);
    }, "");
  }
  getRuleBasedChar(e, t, n, c) {
    const s = e => this.normalize(n[t + e]),
      o = {
        c: this.normalize(e),
        w: this.normalize(c),
        char: e,
        charAtPos: s,
        prev: s(-1),
        next: s(1),
        isVowel: d
      };
    this.debug && console.log(o);
    for (const e of this.def.rules || []) {
      const {
        desc: n,
        cond: s,
        val: i,
        range: r = [0, 1]
      } = e;
      if (s(o)) {
        const e = {
          description: n,
          word: c,
          affectedLetters: [Math.max(t + r[0], 0), t + r[1]]
        };
        return n && this.appliedRules.push(e), i;
      }
    }
  }
  getDictChar(e) {
    return this.def.dict[e.toLowerCase()];
  }
  normalize() {
    let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    const t = new RegExp(`[${this.alphabet.join("")}]`, "i");
    return e.match(t) ? e.toLowerCase() : "";
  }
  clean(e) {
    const t = new RegExp(`([^${this.alphabet.join("")}]+)$`, "ig");
    return e.replace(t, "");
  }
}
const u = [...o, ...i, ...r],
  g = {
    from: "ru",
    to: "en",
    showDetails: !1
  };
function p() {
  let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  let n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const c = e({}, g, n),
    {
      from: s,
      to: o,
      showDetails: i,
      debug: r
    } = c,
    a = u.find(e => e.from === s && e.to === o);
  if (!a) {
    console.error(`No language module ${s}-${o} found`);
    const e = {
      output: t,
      appliedRules: [],
      from: s,
      to: o
    };
    return i ? e : e.output;
  }
  const d = new l(a, !!r).transcribe(t);
  return i ? d : d.output;
}
export { p as transcribe };